import axios from '@/apis/axios';
import { transformRONS} from '@/transformer/transformRONS';

class Client
{
    static async all()
    {
        const response = await axios.get('/api/admin/clients');

        return response.data.data;
    }

    static async create(data)
    {
        const response = await axios.post('/api/admin/clients', transformRONS(data));

        return response.data.data;
    }

    static async update(clientId, data)
    {
        const response = await axios.put(`/api/admin/clients/${clientId}`, transformRONS(data));
        return response.data.data;
    }

    static async delete(clientId)
    {
        const response = await axios.delete(`/api/admin/clients/${clientId}`);
        return response.data.data;
    }

    static async sendRONSMail(clientsData)
    {
        const response = await axios.post('/api/admin/clients/sent-rons-mail', clientsData);
        return response.data.data;
    }

    static async requestGmailAuthUrl()
    {
        const response = await axios.get('/api/admin/gmail-auth-url');

        return response.data;
    }
}

export default Client;
